import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { UserService } from "../services/user.service";

export const isAuthenticated: CanMatchFn = () => {
    const userService = inject(UserService);

    const accessToken = localStorage.getItem("accessToken");
    const user = userService.currentUser();

    if (!accessToken || !user) {
        userService.logout();
        return false;
    }

    return true;
};
